import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssuranceApiService {
  constructor(private readonly _bffApiService: BffCommunicationService) {}

  private getAssuranceApiUrl(): string {
    return `/api/assurances`;
  }

  getInsuranceQuotationUrl(): Observable<any> {
    const requestUrl = `${this.getAssuranceApiUrl()}/habitations/obtenirUrlSoumission`;
    return this._bffApiService.getTxtBFF(requestUrl, null);
  }
}
